import React from "react";
import { Select, Tag, Icon } from "antd";
export class TestCasePriorityInput extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Select
        //name="priority" //mode="multiple"
        style={{ width: "120px" }}
        placeholder="Please select" //defaultValue="1"
        onChange={this.props.onChange}
        {...this.props}
        // dropdownStyle={{ position: "fixed" }}
        getPopupContainer={trigger => trigger.parentNode}
      >
        <Select.Option key="low" value="0">
          <span
            style={{
              color: "#444"
            }}
          >
            <Icon type="exclamation-circle" title={`Low`} />&nbsp; Low
          </span>
        </Select.Option>
        <Select.Option key="normal" value="1">
          <span
            style={{
              color: "#6bd222"
            }}
          >
            <Icon type="exclamation-circle" title={`Normal`} />&nbsp; Normal
          </span>
        </Select.Option>
        <Select.Option key="high" value="2">
          <span
            style={{
              color: "#D2222D"
            }}
          >
            <Icon type="exclamation-circle" title={`High`} />&nbsp; High
          </span>
        </Select.Option>
      </Select>
    );
  }
}
